import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { extrasVM } from '../Extras.page';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { IconButton } from '@design-system/components/button/iconButton';
import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import { ExtrasFilters } from './ExtrasFilters';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import { BasicMenu } from '@client/new/components/BasicMenu/BasicMenu';
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { Alert } from '@design-system/components/alert/alert';

export const ExtrasHeader = () => {
  const [isChanged, setIsChanged] = useState(false);
  const vm = extrasVM.useValue();

  const handleToggleChange = (id: string) => {
    setIsChanged(true);
    vm.dispatch('ToggleItemVisible', id);
    setTimeout(() => {
      setIsChanged(false);
    }, 500);
  };

  if (vm.tabs.length === 0) return null;
  const tabContent = vm.tabs[0];

  return (
    <Col gap="xl">
      <Row alignCenter>
        <Typography
          variant="headline"
          size="large"
          data-testid="extras-page-title"
        >
          Extras
        </Typography>
        {vm.isMutationRunning && (
          <CircularProgress
            size={20}
            style={{ marginLeft: '16px' }}
            data-testid="extras-loading-spinner"
          />
        )}
      </Row>
      <Row alignCenter gap="xl">
        {vm.tabs.map((tab) => {
          const content = vm.contentMap[tab.id];
          if (content.type !== 'ContentTab') return null;
          return (
            <IconButton
              key={content.value.id}
              onClick={() => vm.dispatch('Edit', content.value.id)}
              variant="filled"
              color="neutral"
              icon={faPencil}
              style={{
                flexDirection: 'row-reverse',
                borderRadius: '16px',
                padding: '4px 8px 4px 12px',
              }}
            >
              <Typography variant="title" size="large">
                {content.value.name}
              </Typography>
            </IconButton>
          );
        })}
        <SuperTooltip templateId="extras-details" />
      </Row>

      {vm.isExtrasEmpty && (
        <Alert
          allowClose
          variant="info"
          title="This tab is not visible to your users when empty"
          details="Create some content using the button below to make your tab visible."
        />
      )}

      {!vm.isExtrasEmpty && <ExtrasFilters />}
    </Col>
  );
};
